let login = {
  login: 'Login',
  logout: 'Logout',
  logged_user: 'Autenticado',
  offline_user: 'Não Autenticado',
  confirmLogout: 'Tem certeza que deseja Sair?',
  password: 'Senha',
  signin: 'Entrar',
  rules: {
    loginRules: [
      v => !!v || 'Login é obrigatório',
      v => (v && v.length <= 20) || 'O Login deve ter menos que 20 caracteres'
    ],
    passwordRules: [
      v => !!v || 'Senha é obrigatória',
      v => (v && v.length <= 27) || 'A Senha deve ter menos que 27 caracteres'
    ]
  },
  error: {
    incorrect: 'Login ou Senha incorretos'
  }
}

export default login
